import { render, staticRenderFns } from "./NewResource.vue?vue&type=template&id=52b54cf4&"
import script from "./NewResource.vue?vue&type=script&lang=js&"
export * from "./NewResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports